import { ExportOutlined } from "@ant-design/icons";
import { Button, Carousel, Flex, Space } from "antd";
import { useEffect, useState } from "react";
import RedirectModal from "../RedirectModal";

const ProjectDisplay = ({pages, presentation, link=null}) => {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerHeight < 800);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerHeight < 800);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return(
    <Flex style={{paddingTop:20, width:'100%', maxHeight:'80%'}} vertical justify="center">
      <Space size='large' direction='vertical' >
        <Carousel arrows infinite={false} >
          <div>
            {presentation}
          </div>
          {pages.map((p, index) => (
            <div key={index}>
              <img
                src={p}
                style={{
                  maxWidth: isSmallScreen ? "65%" : "80%", 
                  maxHeight: "80%", 
                  width: "100%", 
                  height: "auto",
                  margin: "auto",
                }}
                alt="project-page"
              />
            </div>
          ))}
        </Carousel>
        <Flex justify="center" style={{width:'100%'}}>
        <Button icon={<ExportOutlined />} style={{color:'black'}} filled disabled={!link} onClick={showModal}>See more</Button>
        <RedirectModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} link={link} />
        </Flex>
      </Space>
    </Flex>
  );
};

export default ProjectDisplay;